import React from "react";
import styles from "./componentHeader.module.css";
import { cx } from "../../Util/classHelpers";

const ComponentHeader = ({ title, children }) => {
  return (
    <div
      className={cx(styles.componentContainer, "row")}
      style={{
        marginBottom: children ? "0px" : "32px",
      }}
    >
      <div className={cx(styles.componentTitle, "col-6")}>{title}</div>
      {children}
    </div>
  );
};

export default ComponentHeader;
